/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Quick_Workout_Minutes_ValueInputs */

const en_us2_quick_workout_minutes_value = /** @type {(inputs: Quick_Workout_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const pt_br2_quick_workout_minutes_value = /** @type {(inputs: Quick_Workout_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const es_419_quick_workout_minutes_value = /** @type {(inputs: Quick_Workout_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const pt_pt2_quick_workout_minutes_value = /** @type {(inputs: Quick_Workout_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const fr_fr2_quick_workout_minutes_value = /** @type {(inputs: Quick_Workout_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const de_de2_quick_workout_minutes_value = /** @type {(inputs: Quick_Workout_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const it_it2_quick_workout_minutes_value = /** @type {(inputs: Quick_Workout_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "{minutes} min" |
*
* @param {Quick_Workout_Minutes_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_minutes_value = /** @type {((inputs: Quick_Workout_Minutes_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Minutes_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_minutes_value(inputs)
	if (locale === "es-419") return es_419_quick_workout_minutes_value(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_minutes_value(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_minutes_value(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_minutes_value(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_minutes_value(inputs)
	return en_us2_quick_workout_minutes_value(inputs)
});
export { quick_workout_minutes_value as "quick-workout.minutes_value" }